

const state = {
    demands: []
};

const getters = {
    allDemands: (state) => state.demands
};


const actions = {
    
    createDemands({ commit }, data ) {
        commit('newDemands', data);
    },
    
    readDemands({ commit }, data ){
        commit('showDemands', data);
    },
    
    updateDemands( { commit }, id){
        commit('changeDemands', id);
    },

    deleteDemands( { commit }, id){
        commit('removeDemands', id);
    },

    
};


const mutations = {
    newDemands: (state, item) => state.demands.unshift(item),

    showDemands: (state, item) => state.demands = item,

    changeDemands: (state, item) => {
        const index = state.demands.findIndex(demand => demand.id == item.id);
        if (index !== -1) {
            state.demands.splice(index, 1, item);
        }
    },

    removeDemands: (state, id) => state.demands = state.demands.filter(demand => demand.id !== id),

};


export default {
    state,
    getters,
    actions,
    mutations
};